import { externalPaths } from "pathnames";

export const config = {
  columns: [
    {
      title: "Pomoc",
      expandable: true,
      links: [
        {
          route: "helpCenterWithQuestion",
          params: {
            categoryId: "inne-zagadnienia",
            questionId: "kontakt",
          },
          text: "Kontakt",
        },
        { route: "helpCenter", text: "Pomoc" },
        {
          href: "https://static.audioteka.com/pl/files/regulamin/Regulamin_serwisu_Audioteka.pdf",
          text: "Regulamin serwisu Audioteka",
        },
        {
          href: "https://web.audioteka.com/legal/pl/Regulamin-Audioteka-Klub.pdf",
          text: "Regulamin usługi Audioteka Klub",
        },
        {
          href: "https://web.audioteka.com/legal/pl/Regulamin-Audioteka-Plus.pdf",
          text: "Regulamin subskrypcji Audioteka Plus",
        },
        { route: "privacyPolicy", text: "Polityka prywatności" },
        { className: "manageGdprButton", text: "Ustawienia prywatności" },
        {
          href: "https://my.audioteka.com/formularz-dsa",
          text: "Formularz zgłaszania nielegalnych treści",
        },
      ],
    },
    {
      title: "Zacznij słuchać",
      expandable: true,
      links: [
        { href: externalPaths.clubLandingPage.pl, text: "Audioteka Klub" },
        { href: "https://pages.audioteka.com/pl/karnety/", text: "Karnety" },
        { href: "https://cards.audioteka.com/", text: "Karty upominkowe" },
        { href: "https://pages.audioteka.com/pl/aktywuj-karte/", text: "Aktywuj kartę" },
        { href: "https://my.audioteka.com/dla-firm", text: "Oferta dla firm i bibliotek" },
      ],
    },
    {
      title: "Przydatne linki",
      expandable: true,
      links: [{ href: `${process.env.SITE_URL}/welcome/`, text: "Wybierz wersję językową", target: "_self" }],
    },
    {
      title: "Aplikacje",
      apps: {
        android: "https://web.audioteka.com/pl/l/android",
        ios: "https://web.audioteka.com/pl/l/ios",
      },
      links: [{ href: "https://audioteka.com/pl/applications", text: "Wszystkie aplikacje" }],
    },
  ],
  social: [
    {
      href: "https://www.facebook.com/audioteka",
      icon: "facebook",
    },
    {
      href: "https://www.youtube.com/user/audiotekapl",
      icon: "youtube",
    },
    {
      href: "https://www.instagram.com/audioteka/",
      icon: "instagram",
    },
    {
      href: "https://twitter.com/audioteka",
      icon: "twitter",
    },
  ],
  copy: `Copyright © 2008-${new Date().getFullYear()} Audioteka Group Sp. z o.o.`,
};
